import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40e79a68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-div" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "columns" }
const _hoisted_4 = { class: "column is-one-third-desktop is-offset-one-third-desktop" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "is-flex is-flex-direction-column is-align-items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://i.imgur.com/uA3fRLZ.png",
    class: "image",
    alt: "logo"
  })
], -1))
const _hoisted_8 = { class: "mt-4" }
const _hoisted_9 = { class: "field" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Schedule appointment", -1))
const _hoisted_11 = { class: "control" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "help" }, "Insert the appointment date and time", -1))
const _hoisted_13 = { class: "field" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Your email", -1))
const _hoisted_15 = { class: "control" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "help" }, "Insert your registered email", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "mt-5 button is-primary is-fullwidth"
}, "Confirm appointment", -1))
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 0,
  class: "is-flex is-flex-direction-column is-align-items-center"
}
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div data-v-40e79a68><img src=\"https://i.imgur.com/uA3fRLZ.png\" class=\"image\" alt=\"logo\" data-v-40e79a68></div><div class=\"mt-5\" data-v-40e79a68><span class=\"fa fa-spinner fa-spin has-text-grey-light fa-6x\" data-v-40e79a68></span></div><div class=\"mt-4 has-text-centered\" data-v-40e79a68><p class=\"is-size-5\" data-v-40e79a68> Confirming appointment... </p></div>", 3)
const _hoisted_23 = [
  _hoisted_20
]
const _hoisted_24 = {
  key: 1,
  class: "is-flex is-flex-direction-column is-align-items-center"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://i.imgur.com/uA3fRLZ.png",
    class: "image",
    alt: "logo"
  })
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-5" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fa fa-times-circle has-text-danger fa-6x" })
], -1))
const _hoisted_27 = { class: "mt-4 has-text-centered" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "is-size-5" }, " Cant activate this appointment! ", -1))
const _hoisted_29 = {
  key: 2,
  class: "is-flex is-flex-direction-column is-align-items-center"
}
const _hoisted_30 = /*#__PURE__*/_createStaticVNode("<div data-v-40e79a68><img src=\"https://i.imgur.com/uA3fRLZ.png\" class=\"image\" alt=\"logo\" data-v-40e79a68></div><div class=\"mt-5\" data-v-40e79a68><span class=\"fa fa-check has-text-success fa-6x\" data-v-40e79a68></span></div><div class=\"mt- has-text-centered\" data-v-40e79a68><p class=\"is-size-5\" data-v-40e79a68> Appointment confirmed </p><p class=\"has-text-grey\" data-v-40e79a68> An email has been sent to you and the user with access details. </p></div>", 3)
const _hoisted_33 = { class: "mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (!_ctx.isEmailFilled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("form", {
                      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.confirmEmail && _ctx.confirmEmail(...args)), ["prevent"]))
                    }, [
                      _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _createElementVNode("div", _hoisted_11, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.datetime) = $event)),
                            class: "input",
                            id: "schedule",
                            required: ""
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.datetime,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ]),
                        _hoisted_12
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createElementVNode("div", _hoisted_15, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
                            class: "input",
                            type: "email",
                            placeholder: "vet@doctor.com",
                            required: ""
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.email,
                              void 0,
                              {
                                trim: true,
                                lazy: true
                              }
                            ]
                          ])
                        ]),
                        _hoisted_16
                      ]),
                      _hoisted_17
                    ], 32)
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                (_ctx.isConfirming)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_23))
                  : _createCommentVNode("", true),
                (!_ctx.isConfirming && !_ctx.isConfirmed)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _hoisted_25,
                      _hoisted_26,
                      _createElementVNode("div", _hoisted_27, [
                        _hoisted_28,
                        _createElementVNode("button", {
                          class: "button is-warning mt-5",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
                        }, "Check inserted email")
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isConfirmed)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _hoisted_30,
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("p", null, [
                          _createVNode(_component_router_link, {
                            to: _ctx.appointmentURL,
                            class: "button is-primary"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Access appointment")
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ])
      ])
    ])
  ]))
}